import { createSlice } from "@reduxjs/toolkit";

const fetchNotificationsSlice = createSlice({
  name: "fetchNotifications",
  initialState: false,
  reducers: {
    setFetchNotifications: (state, action) => {
      return action.payload;
    },
  },
});

export const { setFetchNotifications } = fetchNotificationsSlice.actions;
export default fetchNotificationsSlice.reducer;
